<template>
  <div class="layout my-live">
    <div class="tab_nav">
      <div class="nav_item" :class="{ is_active: index == actIndex }" @click="tabChange(index)" v-for="(item, index) in navList" :key="index">{{ item }}</div>
    </div>
    <div class="tab_content">
      <div class="list_wrap">
        <List v-model="loading" :finished="finished" @load="loadMore">
          <div class="item_div" v-for="(item, index) in list" :key="index" @click="LinkAct(item)">
            <div class="img_div">
              <img v-if="item.banners" :src="item.banners" v-load="'oActSmall'" />
              <img v-else src="@/assets/img/empty.png" />
            </div>
            <div class="item_info">
              <div class="item_title">
                <p class="van-ellipsis">{{ item.title }}</p>
                <template v-if="item.acvitityType == 'LIVE' && (item.liveAuditState == 'PASS' || item.liveAuditState == 'Pass')">
                  <div class="is_live is_liveing" v-if="item.liveStateIndex === 1"><span></span>直播中</div>
                  <div class="is_live" v-else-if="item.liveStateIndex === 2"><i class="iconfont icon-zhibo"></i>有直播</div>
                  <div class="is_live is_end" v-else-if="item.hasLive">直播回看</div>
                </template>
              </div>
              <p class="van-ellipsis item_date">{{ item.dateTime }}</p>
              <p class="van-ellipsis item_site" v-if="item.company">{{ item.company.name }}</p>
              <div class="van-ellipsis ex_info">
                <p>
                  <i class="iconfont icon-fenxiang2"></i>
                  <span>{{ wCount(item.shareCount) }}</span>
                </p>
                <p>
                  <i class="iconfont icon-zhiboguankanshu"></i>
                  <span>{{ wCount(item.viewCount) }}</span>
                </p>
                <p>
                  <i class="iconfont icon-huabanfuben"></i>
                  <span>{{ wCount(item.followCount) }}</span>
                </p>
              </div>
            </div>
          </div>
          <div slot="loading" class="f-tac loading">
            <img src="@assets/img/new/icon-loading.png" />
            loading...
          </div>
          <div slot="finished" class="f-tac loading">It's the end~</div>
        </List>
      </div>
    </div>
  </div>
</template>
<script>
import gql from "graphql-tag";
import moment from "moment";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { List } from "vant";
export default {
  name: "my-live",
  components: {
    List,
  },
  data() {
    return {
      actIndex: 0,
      navList: ["我关注的", "我浏览的"],
      loading: false, //直播列表加载状态
      finished: false, //直播列表是否完成状态
      list: [], //直播列表
      pageIndex: 0,
      pageSize: 20,
      queryActivityFollow: {},
      queryActivityView: {},
    };
  },
  async created() {
    this.$store.commit("setExhibitionId", this.$route.params.id);
    if (!this.userInfo) {
      await this.$Myapollo.getUserInfo(this);
    }
    this.actIndex = this.myLiveHead;
  },
  mounted() {},
  computed: {
    ...mapGetters({
      myLiveHead: "getMyLiveHead",
      userInfo: "getUserInfo",
      exhibitionId: "getExhibitionId",
    }),
  },
  methods: {
    ...mapActions({
      LinkAct: "linkTo/LinkAct",
    }),
    wCount(value) {
      //过万处理
      let num = value;
      if (value > 9999) {
        //大于9999显示x.xx万
        num = Math.floor(value / 100) / 100 + "w";
      } else {
        num = value;
      }
      return num;
    },
    tabChange(index) {
      if (index == this.actIndex) {
        return;
      }
      this.$store.commit("setMyLiveHead", index);
      this.actIndex = index;
      this.pageIndex = 0;
      this.list = [];
      this.finished = false;
      // if(index==0){
      //   this.getFollowList();
      // }else{
      //   this.getViewList()
      // }
    },
    getFollowList() {
      let query = gql`
        query queryActivityFollow($query: QueryInput!) {
          queryActivityFollow(query: $query) {
            hasNextPage
            indexFrom
            pageIndex
            pageSize
            items {
              activity {
                auditState
                id
                title
                banners
                startTime #开始时间
                endTime #结束时间
                shareCount #分享数
                viewCount #浏览数
                followCount #关注数
                acvitityType #活动类型，0/ExternalLink：外链、1/Live：直播、 2/Registration：报名
                externalLink #外链地址
                stateIndex #活动进行状态 1：进行中、2：未开始：3：已结束
                liveStateIndex
                liveAuditState
                hasLive
                company {
                  id
                  name
                }
              }
            }
          }
        }
      `;
      let where = {
        Equal: {
          n: "userId",
          v: this.userInfo.userId,
        },
        EqualB: {
          n: "exhibitionId",
          v: this.exhibitionId,
        },
        EqualC: {
          n: "hasLive",
          v: 1,
        },
      };
      let order = [
        {
          N: "createAt",
          v: 0,
        },
      ];
      let opt = {
        page: this.pageIndex,
        size: this.pageSize,
        where: JSON.stringify(where),
        order: JSON.stringify(order),
      };
      this.$apollo.addSmartQuery("queryActivityFollow", {
        query: query,
        variables: {
          query: opt,
        },
        fetchPolicy: "network-only", //清理缓存
        result(data) {
          let res = JSON.parse(JSON.stringify(data.data.queryActivityFollow));
          // let res=data.data.queryProduct;
          console.log("关注直播", res);
          let items = [];
          if (res && res.items.length) {
            res.items.forEach((el) => {
              if (el.activity) {
                items.push(el.activity);
              }
            });
          }
          if (items.length) {
            items.forEach((e) => {
              if (e.banners && e.banners.indexOf("[") != -1) {
                let banArr = JSON.parse(e.banners);
                e.banners = banArr[0];
              }
              let str = moment(e.startTime).format("MM/DD HH:mm");
              str += "~" + moment(e.endTime).format("MM/DD HH:mm");
              e.dateTime = str;
            });
          }
          if (this.pageIndex == 1) {
            this.list = items;
          } else {
            this.list = [...new Set([...this.list, ...items])];
          }
          // console.log(this.list,'list');
          this.loading = false;
          if (!res.hasNextPage) {
            this.finished = true;
          }
        },
        error(err) {
          this.loading = false;
          this.finished = true;
          console.log("err", err);
        },
      });
    },
    getViewList() {
      let query = gql`
        query queryActivityView($query: QueryInput!) {
          queryActivityView(query: $query) {
            hasNextPage
            indexFrom
            pageIndex
            pageSize
            items {
              activity {
                auditState
                id
                title
                banners
                startTime #开始时间
                endTime #结束时间
                shareCount #分享数
                viewCount #浏览数
                followCount #关注数
                acvitityType #活动类型，0/ExternalLink：外链、1/Live：直播、 2/Registration：报名
                externalLink #外链地址
                stateIndex #活动进行状态 1：进行中、2：未开始：3：已结束
                liveStateIndex
                liveAuditState
                hasLive
                company {
                  id
                  name
                }
              }
            }
          }
        }
      `;
      let where = {
        Equal: {
          n: "userId",
          v: this.userInfo.userId,
        },
        EqualB: {
          n: "exhibitionId",
          v: this.exhibitionId,
        },
        EqualC: {
          n: "hasLive",
          v: 1,
        },
      };
      let order = [
        {
          N: "createAt",
          v: 0,
        },
      ];
      let opt = {
        page: this.pageIndex,
        size: this.pageSize,
        where: JSON.stringify(where),
        order: JSON.stringify(order),
      };
      this.$apollo.addSmartQuery("queryActivityView", {
        query: query,
        variables: {
          query: opt,
        },
        fetchPolicy: "network-only", //清理缓存
        result(data) {
          let res = JSON.parse(JSON.stringify(data.data.queryActivityView));
          // let res=data.data.queryProduct;
          console.log("直播访问用户", res);
          let items = [];
          if (res && res.items.length) {
            res.items.forEach((el) => {
              if (el.activity) {
                items.push(el.activity);
              }
            });
          }
          if (items.length) {
            items.forEach((e) => {
              if (e.banners && e.banners.indexOf("[") != -1) {
                let banArr = JSON.parse(e.banners);
                e.banners = banArr[0];
              }
              let str = moment(e.startTime).format("MM/DD HH:mm");
              str += "~" + moment(e.endTime).format("MM/DD HH:mm");
              e.dateTime = str;
            });
          }
          if (this.pageIndex == 1) {
            this.list = items;
          } else {
            this.list = [...new Set([...this.list, ...items])];
          }
          this.loading = false;
          if (!res.hasNextPage) {
            this.finished = true;
          }
        },
        error(err) {
          this.loading = false;
          this.finished = true;
          console.log("err", err);
        },
      });
    },
    loadMore() {
      if (this.finished) return;
      this.pageIndex += 1;
      if (this.actIndex == 0) {
        this.getFollowList();
      } else {
        this.getViewList();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.my-live {
  background: #fff;
  padding: 0.9rem 0 0;
  .tab_nav {
    background: #fff;
    position: fixed;
    top: 0;
    left: 0;
    height: 0.9rem;
    width: 100%;
    display: flex;
    z-index: 99;
    justify-content: space-between;
    align-items: center;
    padding: 0 1.02rem;
    border-bottom: 1px solid #e6e6e6;
    .nav_item {
      color: #666;
      width: 2rem;
      height: 0.48rem;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 0.48rem;
      font-size: 0.26rem;
      &.is_active {
        color: #fff;
        background: #1890ff;
      }
    }
  }
  .tab_content {
    padding: 0 0.3rem 0.3rem;
    .list_wrap {
      .item_div {
        padding: 0.26rem 0;
        border-top: 1px solid #e6e6e6;
        display: flex;
        &:first-child {
          border: none;
        }
        .img_div {
          flex-shrink: 0;
          position: relative;
          height: 1.44rem;
          width: 2.2rem;
          border-radius: 0.05rem;
          border: 1px solid #e6e6e6;
          overflow: hidden;
          margin-right: 0.2rem;
          img {
            width: 100%;
            height: 100%;
            // object-fit: cover;
          }
        }
        .item_info {
          max-width: calc(100% - 2.4rem);
          display: flex;
          margin-bottom: -0.05rem;
          justify-content: space-between;
          flex-direction: column;
          color: #666;
          .item_title {
            display: flex;
            align-items: center;
            p {
              font-size: 0.26rem;
              font-weight: bold;
              color: #333;
            }
            .is_live {
              width: 0.88rem;
              height: 0.3rem;
              display: flex;
              flex-shrink: 0;
              justify-content: center;
              align-items: center;
              color: #fff;
              margin-left: 0.15rem;
              border-radius: 0.05rem;
              background-image: linear-gradient(90deg, #56ccf2 0%, #2f80ed 100%);
              font-size: 0.18rem;
              &.is_liveing {
                background-image: linear-gradient(90deg, #ff416c 0%, #ff4b2b 100%);
              }
              &.is_ac_end {
                background: #bfbfbf;
              }
              &.is_end {
                background-image: linear-gradient(90deg, #ffc659 0%, #ffa751 100%), linear-gradient(#000, #000);
              }
              span {
                display: block;
                height: 0.12rem;
                width: 0.12rem;
                margin-right: 0.05rem;
                border-radius: 50%;
                background: #fff;
              }
              .iconfont {
                color: #fff;
                font-size: 0.24rem;
                margin-left: -0.04rem;
              }
            }
          }
          .item_date {
            font-size: 0.2rem;
          }
          .item_site {
            font-size: 0.22rem;
          }
          .ex_info {
            color: #999;
            display: flex;
            p {
              margin-right: 0.1rem;
              display: flex;
              align-items: center;
              span {
                font-size: 0.2rem;
              }
            }
          }
        }
      }
    }
  }
}
.f-tac {
  text-align: center;
}
.loading {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 18px;
    height: 18px;
    display: inline-block;
    margin-right: 5px;
    animation: 1s loader-01 linear infinite;
  }
}
@keyframes loader-01 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
